import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../Navbar'
import Footer from '../Footer'
import './Layout.css'

const Layout = ({ cartItems,  setCartItemsCount  }) => {
    return (
        <div className='layout-container'>
            <Navbar cartItems={cartItems} setCartItemsCount={setCartItemsCount} />
            <div className='layout_content'>
                <section className='py-1 px-0 py-lg-4 px-lg-1'>
                    <div className='container-fluid'>
                    <Outlet />
                    </div>
                </section>
                <Footer />
            </div>
        </div>
    )
}

export default Layout
